import React from 'react';
import { FormGroup } from './Report1099Field.styles';
import { ComboBoxInput, TextBlock } from 'bench-internal-theme';
import { Report1099Fields } from '../report-1099-form/types';

type report1099Fieldprops = {
  name: string;
  options: any | { value: string | null; label: string };
  onChange: (option: any) => void;
  fields: Report1099Fields;
  isDisabled?: boolean;
  placeholder?: string;
};

const Report1099Field = ({
  name,
  options,
  onChange,
  fields,
  isDisabled,
  placeholder,
}: report1099Fieldprops) => {
  return (
    <>
      <FormGroup>
        <TextBlock as="label" htmlFor={name.toLowerCase()} styleType="small" uppercase>
          {name}
        </TextBlock>
        <ComboBoxInput
          key={fields.key}
          value={options?.find(option => option.value === fields.value)}
          isSearchable
          menuPlacement="top"
          menuPortalTarget={document.body}
          name={name.toLowerCase()}
          inputId={name.toLowerCase()}
          onChange={onChange}
          options={options}
          isDisabled={isDisabled}
          placeholder={placeholder}
        />
      </FormGroup>
    </>
  );
};

export default React.memo(Report1099Field);
